import { DashboardHeader, DashboardLoader } from '../features/dashboard'

export const DashboardPage = () => (
  <>
    <DashboardHeader />
    <DashboardLoader />
  </>
)
